import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router';
import CommonModal from '../../components/CommonModal';
import { Dialog } from '../../components/CommonComponents/Dialog/Dialog';
import axios from 'axios';
import { _axios } from "../../utils/axios";
import { ErrorToast, SuccessToast } from '../../components/toastMessage';
import tickGreen from "../../assets/images/gif/geentick.gif"
import cross from "../../assets/images/gif/cross.gif"
import { BASE_URL } from '../../constants/Constants';
import returnGif from "../../assets/images/gif/return.gif";
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import ActionDialog from '../../components/CommonComponents/DialogConfirmation/ActionDialog';
import { DocumentPreviewDialog } from '../../components/CommonComponents/DialogConfirmation/DocPreviewDialog';
import { getDocumentTypesByUserType } from '../LevelTwo/LevelTwo.constants';

const userApprovalDetails = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { userDetails } = state
    const [isModal, setIsModal] = useState(false)
    const [document, setDocument] = useState('')
    const [comment, setComment] = useState('')
    const [commentList, setCommentList] = useState<any>([])
    const [isApproveModal, setIsApproveModal] = useState(false);
    const [isReturnModal, setIsReturnModal] = useState(false);

    const handleClose = (modalType: 'approve' | 'return') => {
        navigate('/user-approvals', { state: { isUpdated: true } });
        if (modalType === 'approve') {
          setIsApproveModal(false);
        } else {
          setIsReturnModal(false);
        }
      };

      
    const toggleModal = (document: string) => {
        setDocument(document)
        setIsModal(true)
    }
    const getComments = () => {
        _axios.post(`${BASE_URL}/api/user-verification-comments/admin`,
            {
                user_id: userDetails?.userId
            }
        )
            .then(function (response) {
                if (response?.data?.success === 0) {
                    ErrorToast(response?.data?.message)
                    return
                }
                console.log('response?.data', response?.data)
                setCommentList(response?.data?.data)
            })
            .catch(function (error: any) {
                // handle error
                console.log(error);
            })
    }

    useEffect(() => {
        getComments()
    }, [])

    const updateUserVerificationDetails = (isReturn: boolean) => {
        _axios.patch(`${BASE_URL}/api/user-details`,
            {
                user_id: userDetails?.userId,
                regestration_status: isReturn ? '3' : '1'
            }
        )
            .then(function (response) {
                if (response?.data?.success === 0) {
                    ErrorToast(response?.data?.message)
                    return
                }
                if (isReturn) {
                    setIsReturnModal(true)
                }
                else {
                    setIsApproveModal(true)
                }
            })
            .catch(function (error: any) {
                // handle error
                console.log(error);
            })
    }

    const onApproveOrReturn = (isReturn = false) => {
        _axios.post(`${BASE_URL}/api/user-verification-comments`,
            {
                user_id: userDetails?.userId,
                name: userDetails?.name,
                email: userDetails?.email,
                comment: comment,
                comments_by: "Level 3",
                status: isReturn ? 0 : 1
            }
        )
            .then(function (response) {
                if (response?.data?.success === 0) {
                    ErrorToast(response?.data?.message)
                    return
                }
                updateUserVerificationDetails(isReturn)

            })
            .catch(function (error: any) {
                // handle error
                console.log(error);
            })


    }

    const isImageUrl = (url: string) => {
        return /\.(jpg|jpeg|png|svg)$/.test(url);
    };

    const docsToRender = getDocumentTypesByUserType(
        userDetails?.user_type,
        userDetails?.document_type
      );

    return (
        <>
            <div className="no-scrollbar">
                <div className="m-5 bg-white rounded-xl shadow-lg border border-gray-300 p-5">
                    <h3 className="text-center my-3 text-xl font-bold">Application Details</h3>

                    {/* <div className="grid grid-cols-1 md:grid-cols-2 p-5 gap-5"> */}
                    <div className="grid grid-cols-2 gap-5">
                        <div className="flex justify-between items-center col-span-2 md:col-span-1 gap-2">
                            <p className="font-bold basis-1/3">Name</p>
                            <p className="text-muted basis-2/3 ">{userDetails?.name || "--"}</p>
                        </div>
                        <div className="flex justify-between items-center col-span-2 md:col-span-1 gap-2">
                            <p className="font-bold basis-1/3">Email</p>
                            <p className="text-muted basis-2/3 ">{userDetails?.email || "--"}</p>
                        </div>
                        <div className="flex justify-between items-center col-span-2 md:col-span-1 gap-2">
                            <p className="font-bold basis-1/3">Mobile Number</p>
                            <p className="text-muted basis-2/3 ">{userDetails?.mobile_number || "--"}</p>
                        </div>
                        <div className="flex justify-between items-center col-span-2 md:col-span-1 gap-2">
                            <p className="font-bold basis-1/3">Aadhaar/Other Govt.ID</p>
                            <p className="text-muted basis-2/3">{userDetails?.gov_id_number || "-"}</p>
                        </div>
                        <div className="flex justify-between items-center col-span-2 md:col-span-1 gap-2">
                            <p className="font-bold basis-1/3">Office Address</p>
                            <p className="text-muted basis-2/3">{userDetails?.office_address || "-"}</p>
                        </div>
                    </div>

                    <div className="py-5 flex flex-wrap gap-10">
                        {docsToRender
                            ?.filter((e) => !!userDetails[e.key])
                            .map((e) => (
                            <div
                                className="flex justify-between items-center w-full md:w-1/2"
                                key={e.key}
                            >
                                <p className="font-bold ">{e.label}</p>
                                <button
                                onClick={() => toggleModal(userDetails?.[e.key])}
                                className="px-4 py-1.5 border-amber-400 border rounded-md items-center justify-around"
                                >
                                View
                                <i className="ml-2 mr-0 fa fa-eye text-primary"></i>
                                </button>
                            </div>
                        ))}
                    </div>

                    <div className="pr-5 pt-5">
                        {commentList?.map((item: any) => {
                            return (
                                <div>
                                    <p className='font-bold justify-around mb-1'>{item.comments_by ?? ''} {' Reviewer Remark'}</p>
                                    <p className=' justify-around'>{item?.comment ?? ''}</p>
                                </div>
                            )
                        })}
                        {userDetails?.regestration_status == 2 && <>
                            <p className="font-bold justify-around my-4">
                                Level 3 Reviewer Remark <span className="text-red-500">*</span>
                            </p>
                            <div className="flex gap-4 flex-wrap md:flex-nowrap items-center">
                                <textarea
                                    value={comment}
                                    className="basis-full md:basis-4/5"
                                    placeholder="Add Comment"
                                    onChange={(e) => setComment(e.target.value)}
                                />
                                <div className="flex gap-4 justify-evenly md:flex-col  basis-full md:basis-1/5">
                                    <button
                                        disabled={comment.length === 0}
                                        onClick={() => onApproveOrReturn(true)}
                                        className={`text-base font-bold text-white py-1.5 rounded-md md:block md:w-full px-4 basis-1/2 ${comment.length === 0 ? 'bg-gray-400' : 'bg-red-400'}`}
                                    >
                                        {"Return"}
                                    </button>
                                    <button
                                        disabled={comment.length === 0}
                                        onClick={() => onApproveOrReturn(false)}
                                        className={`text-base font-bold text-white py-1.5 rounded-md md:block md:w-full px-4 basis-1/2 ${comment.length === 0 ? 'bg-gray-400' : 'bg-green-600'}`}
                                    >
                                        {"Approve"}
                                    </button>
                                </div>
                            </div>
                        </>}
                        <div className="flex justify-center items-center mt-4">
                            <button
                                type="button"
                                onClick={() => navigate("/user-approvals")}
                                className="bg-black px-6 py-2 rounded-full font-bold text-white"
                            >
                                Close
                            </button>
                        </div>
                    </div>

                </div>
            </div>
            <DocumentPreviewDialog onClose={() => setIsModal(false)} open={isModal}>
    <div className="w-full h-full overflow-auto">
        {isImageUrl(document) ? (
            <img 
                src={document ?? ""}
                className="object-contain mx-auto"
                alt="Document"
            />
        ) : (
            <Worker workerUrl={`https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js`}>
                <Viewer fileUrl={(document ?? "") + '#toolbar=0&zoom=full'} />
            </Worker>
        )}
    </div>
</DocumentPreviewDialog>

            <ActionDialog
        isOpen={isApproveModal}
        onClose={() => handleClose('approve')}
        actionType="approved"
        imageSrc={tickGreen}
        title="Application Approved"
        description="User application approved. Status sent to user."
        navigateTo="/user-approvals"
      />

      <ActionDialog
        isOpen={isReturnModal}
        onClose={() => handleClose('return')}
        actionType="return"
        imageSrc={returnGif}
        title="Application Returned"
        description="User application returned. Status sent to user."
        navigateTo="/user-approvals"
      />
        </>
    )
}

export default userApprovalDetails
